import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ConstantsModule } from './../constants/constants.module';
import { DialogPage } from './../root_classes/dialog-page';

@Component({
	selector: 'app-folder-reminder',
	templateUrl: './folder-reminder.component.html',
	styleUrls: ['./folder-reminder.component.scss']
})
export class FolderReminderComponent extends DialogPage implements OnInit {

	public folderId: string = "";
	public folderName: string = "";

	// Form data.
	folderReminderForm = new FormGroup({
		subjectReminderControl: new FormControl(''),
		emailReminderControl: new FormControl(''),
		sendToEngineerControl: new FormControl(true),
		sendToAdminsControl: new FormControl(true),
	});

	// Extra data.
	public buttonText: string;
	public enableAction: boolean;

	constructor(constantsModule:ConstantsModule, cookieService:CookieService, httpClient:HttpClient, router: Router, modalService: NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button info.
		this.buttonText = "Envoyer";
		this.enableAction = true;
	}

	ngOnInit(): void {
		this.folderReminderForm.controls["subjectReminderControl"].setValue(this.constantsModule.mailTemplateFolderReminderSubject);
		this.folderReminderForm.controls["emailReminderControl"].setValue(this.constantsModule.mailTemplateFolderReminder);
	}

	public setModalOptions(data:any):void {
		this.folderId = data["id"];
		this.folderName = data["name"];
	}

	public sendReminder():void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			folderid:this.folderId,
			subject:this.folderReminderForm.controls["subjectReminderControl"].value,
			email:this.folderReminderForm.controls["emailReminderControl"].value,
			sendToEngineer:this.folderReminderForm.controls["sendToEngineerControl"].value,
			sendToAdmins:this.folderReminderForm.controls["sendToAdminsControl"].value
		};

		this.put("/api/folder-reminder", newData,
			(response:any) => {
				this.modalInstance.dismiss({DATA:"OK", NB:response.NB});
			},
			(err:any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
